import { Link } from 'react-router-dom';

const encyclopediaTopics = [
  {
    icon: 'ri-presentation-line',
    title: 'Корпоративные тренинги',
    description: 'Что такое корпоративное обучение, его виды, преимущества и современные подходы к развитию персонала.',
    to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie',
    label: 'Подробнее',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Обучение отдела продаж',
    description: 'Как повысить конверсию, улучшить работу с возражениями и увеличить продажи через системное обучение менеджеров.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
    label: 'Подробнее',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Развитие руководителей',
    description: 'Формирование управленческих компетенций, лидерских качеств и навыков эффективного управления командой.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
    label: 'Подробнее',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: 'Soft Skills',
    description: 'Развитие эмоционального интеллекта, коммуникаций, стресс-менеджмента и других гибких навыков сотрудников.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
    label: 'Подробнее',
  },
  {
    icon: 'ri-team-line',
    title: 'Командообразование',
    description: 'Формирование сплоченных команд, улучшение взаимодействия и корпоративной культуры через тимбилдинги.',
    to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie',
    label: 'Подробнее',
  },
  {
    icon: 'ri-user-add-line',
    title: 'Адаптация сотрудников',
    description: 'Построение системы онбординга для быстрого вхождения новых сотрудников в должность и снижения текучести.',
    to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov',
    label: 'Подробнее',
  },
  {
    icon: 'ri-building-line',
    title: 'Корпоративная академия',
    description: 'Создание внутреннего учебного центра для масштабирования знаний и стандартов работы в компании.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
    label: 'Подробнее',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Оценка эффективности обучения',
    description: 'Методы измерения результативности: модель Киркпатрика, ROI обучения, KPI и показатели внедрения.',
    to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya',
    label: 'Подробнее',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Разработка программ обучения',
    description: 'Как создать эффективную программу под задачи бизнеса: от диагностики до внедрения и сопровождения.',
    to: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya',
    label: 'Подробнее',
  },
];

export default function WhatIsIncluded() {
  return (
    <section id="what-included" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Что входит в современное корпоративное обучение
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Полный спектр направлений для построения системы обучения: от базовых тренингов до корпоративных академий и оценки эффективности.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {encyclopediaTopics.map((card) => (
            <div key={card.title} className="bg-white rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-all duration-300 flex flex-col h-full">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-5">
                <i className={`${card.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{card.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">{card.description}</p>
              <Link
                to={card.to}
                className="inline-flex items-center gap-2 text-teal-600 font-semibold text-sm hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-auto"
              >
                {card.label}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}